export const WIDGET_THEME = {
      // Core colors
      primaryColor: '#1976d2',        // Accessible blue (WCAG AA compliant)
      primaryColorLight: '#42a5f5',   // Lighter blue
      primaryColorDark: '#0d47a1',    // Darker blue
      backgroundColor: '#f5f7fa',
      textColor: '#222222',
      textColorInverted: '#ffffff',
      
      // UI elements
      buttonSize: '48px',
      cardBackground: '#ffffff',
      borderColor: '#d1d5db',
      focusRingColor: '#1976d2',      // Match primary
      
      // Interactive states
      hoverColor: '#42a5f5',          // Use light blue for hover
      activeColor: '#0d47a1',         // Use dark blue for active
      
      // Feedback colors
      successColor: '#2e7d32', // Green
      errorColor: '#c62828', // Red
      warningColor: '#f57c00', // Orange
      
      // Other UI properties
      headerHeight: '64px',
      borderRadius: '8px',
      buttonBorderRadius: '0.4rem',
      menuPosition: '', // optional 'left' | 'right'; empty follows the button position
      zIndex: 100000,
      
      // WCAG-specific
      focusBorderWidth: '3px',
      focusOutlineOffset: '2px'
    };
